import React,{useState} from 'react';
import './style/Main.scss';
import {GrRotateLeft,GrRotateRight} from 'react-icons/gr';
import {CgMergeVertical,CgMergeHorizontal} from 'react-icons/cg';
import {
    // IoMdUndo,IoMdRedo,
    IoIosImage} from 'react-icons/io';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import storedData from './LinkedList';

const Main = () => {
    const [ details,setDetails ] = useState('');
    const [ crop,setCrop ] = useState({});
    const [sourceImage,setSourceImage] = useState({
        image:'',
        brightness:100,
        GrayScale:0,
        Sepia:0,
        Saturate:100,
        Contrast:100,
        hueRotate:0,
        rotate:0,
        vertical:1,
        horizotal:1
    });
    const [image,setImage] = useState({
        image:'',
        brightness:100,
        GrayScale:0,
        Sepia:0,
        Saturate:100,
        Contrast:100,
        hueRotate:0,
        rotate:0,
        vertical:1,
        horizotal:1
    });
    const inputHandle = (e) => {
        setImage(
            {
                ...image,
                [e.target.name] : e.target.value 
            }
        )
    }
    const handleImage = (e) => {
        if(e.target.files.length !== 0){
            console.log('ok');
            const reader = new FileReader()
            console.log('here')
            reader.onload = () => {
                setImage({...image,image : reader.result})
                const stateData = {
                    image:reader.result,
                    brightness:100,
                    GrayScale:0,
                    Sepia:0,
                    Saturate:100,
                    Contrast:100,
                    hueRotate:0,
                    rotate:0,
                    vertical:1,
                    horizotal:1
                }
                storedData.insert(stateData);
                setSourceImage(
                    {
                        ...sourceImage,
                        image:reader.result,
                    }
                );

            }
            reader.readAsDataURL(e.target.files[0])
        }
    }
    const FilterElement = [
        {
            name : 'brightness',
            ar : 'السطوع',
            maxValue:200
        },
        {
            name : 'GrayScale',
            ar : 'درجات الرمادي',
            maxValue:200
        },
        {
            name : 'Sepia',
            ar : 'بني داكن',
            maxValue:200
        },
        {
            name : 'Saturate',
            ar : 'الاشباع',
            maxValue:200
        },
        {
            ar : 'التباين',
            name : 'Contrast',
            maxValue:200
        },
        // {
        //     name : 'hueRotate'
        // },
    ]
    const [property,setProperty] = useState(
        {
            name : 'brightness',
            maxValue:200
        }
    );
    const leftRotate = () => {
        setImage(
            {
                ...image,
                rotate:image.rotate - 90
            }
        )
        const stateData = image
        stateData.rotate = image.rotate - 90
        storedData.insert(stateData)
    }
    const rightRotate = () => {
        setImage(
            {
                ...image,
                rotate:image.rotate + 90
            }
        )
        const stateData = image
        stateData.rotate = image.rotate + 90
        storedData.insert(stateData)
    }
    const verticalFlip = () => {
        setImage(
            {
                ...image,
                vertical:image.vertical === 1 ? -1:1
            }
        )
        const stateData = image
        stateData.vertical = image.vertical === 1 ? -1:1
        storedData.insert(stateData)
    }
    const horizentalFlip = () => {
        setImage(
            {
                ...image,
                horizotal:image.horizotal === 1 ? -1 : 1
            }
        )
        const stateData = image
        stateData.horizotal = image.horizotal === 1 ? -1 : 1
        storedData.insert(stateData)
    }
    // const redo = () => {
    //     const data = storedData.redoEdit()
    //     if(data){
    //         setImage(data)
    //     }
    // }
    // const undo = () => {
    //     const data = storedData.undoEdit()   
    //     if(data){
    //         setImage(data)
    //     }
    // }
    const reset = () => {
        console.log('reset')
        setImage({
            image:sourceImage.image,
            brightness:100,
            GrayScale:0,
            Sepia:0,
            Saturate:100,
            Contrast:100,
            hueRotate:0,
            rotate:0,
            vertical:1,
            horizotal:1
        })
        // const data = storedData.resetEdit()   
        // if(data){
        //     setImage(data)
        // }
    }
    const imageCrop = () => {
        const canvas = document.createElement('canvas')
        const scaleX = details.naturalWidth / details.width
        const scaleY = details.naturalHeight / details.height
        canvas.width = crop.width 
        canvas.height = crop.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(
            details,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        )
        const base64Url = canvas.toDataURL('image/jpg')
        setImage(
            {
                ...image,
                image:base64Url
            }
        )
        setCrop('');
    }
    const saveImage = () => {
        const canvas = document.createElement('canvas')
        canvas.width = details.naturalWidth
        canvas.height = details.naturalHeight
        const ctx = canvas.getContext('2d')
        ctx.filter = `brightness(${image.brightness}%) 
        grayscale(${image.GrayScale}%) 
        contrast(${image.Contrast}%) 
        sepia(${image.Sepia}%) 
        saturate(${image.Saturate}%)`
        ctx.translate(canvas.width / 2 , canvas.height / 2)
        ctx.rotate(image.rotate * Math.PI / 180)
        ctx.scale(image.vertical,image.horizotal)
        ctx.drawImage(
            details,
            -canvas.width/2,
            -canvas.height/2,
            canvas.width,
            canvas.height
        )
        const link = document.createElement('a')
        link.download = 'image_edited.jpg'
        link.href = canvas.toDataURL()
        link.click()
    }

  return (
    <div className='imageEditor'>
        <div className='card'>
            <div className='card_header'>
                <h2>برنامج خاص بتعديل الصور</h2>
            </div>
            <div className='card_body'>
                <div className='sidebar'>
                     <div className='sidebody'>
                        <div className='filter_section'>
                            <span>الفلاتر</span>
                            <div className='filter_key'>
                                {
                                    FilterElement.map((item,index) => 
                                    <button key={index}
                                            className={property.name === item.name ? 'active' : ''} 
                                            onClick={()=>setProperty(item)}>
                                        {item.ar}
                                    </button>
                                    )
                                } 
                            </div> 
                        </div>
                        <div className='fltier_slider'>
                                <div className='label_bar'>
                                    <label htmlFor='range'>{property.ar}</label>
                                    <span>{image[property.name]}%</span>
                                </div>
                                <input name={property.name} onChange={inputHandle} value={image[property.name]} max={property.maxValue} type="range"/>
                        </div>
                        <div className='rotate'>
                                <label htmlFor=''>التدوير و القلب</label>
                                <div className='icon'>
                                    <div onClick={leftRotate}>
                                        <GrRotateLeft/>
                                    </div>
                                    <div onClick={rightRotate}>
                                        <GrRotateRight/>
                                    </div>
                                    <div onClick={horizentalFlip}>
                                        <CgMergeHorizontal/>
                                    </div>
                                    <div onClick={verticalFlip}>
                                        <CgMergeVertical/>
                                    </div>
                                </div>
                        </div> 
                    </div>
                    <div className='reset'>
                        <button onClick={reset}>
                            إعادة
                        </button>
                        <button onClick={saveImage}>
                            حفظ
                        </button>
                    </div> 
                </div>
                <div className='Image_section'>
                    <div className='Image'>
                        {
                            image.image ? 
                            <ReactCrop crop={crop} onChange={(c) => setCrop(c)} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                <img onLoad={(e) => setDetails(e.currentTarget)} style={{
                                filter:`brightness(${image.brightness}%) 
                                grayscale(${image.GrayScale}%) 
                                contrast(${image.Contrast}%) 
                                sepia(${image.Sepia}%) 
                                saturate(${image.Saturate}%) 
                                `,
                                // hue-Rotate(${image.hueRotate} deg)
                                transform:`rotate(${image.rotate}deg) scale(${image.vertical},${image.horizotal})`

                            }} src={image.image} alt=''/>
                            </ReactCrop> :
                            <label htmlFor='choose'>
                            <IoIosImage/>
                            <span>اختر صورة</span>
                        </label> 
                        }
                        
                    </div>
                    <div className='Image_select'>
                        {/* <button onClick={undo} className='undo'>
                            <IoMdUndo/>
                        </button>
                        <button onClick={redo} className='redo'>
                            <IoMdRedo/>
                        </button> */}
                        {
                            crop && details && <button onClick={imageCrop} className='crop'>
                                اقتصاص
                            </button>
                        }
                        {   !crop  &&
                            <p style={{color:'rgb(100,149,237)',width:'200px',height:'35px',display:'flex',alignItems:'center'}}>حدد جزء من الصورة للاقتصاص</p>
                        }
                        <label htmlFor='choose'>اختر صورة</label>
                        <input onChange={handleImage} type='file' id='choose'/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Main